<template>
  <div>
    <div class="full-height">
      <v-row justify="center" style="height: 90%">
        <v-col cols>
          <div class="d-flex justify-end">
            <v-btn color="primary" text @click="addMoreAccreditations()">
              <v-icon>add</v-icon>Add {{ getFieldAlias(230).Field_Alias }}
            </v-btn>
          </div>
          <v-form
            v-for="(accreditation, index) in addAccreditations"
            :key="index"
            :ref="'accreditationForm' + index"
          >
            <div
              v-if="
                (addAccreditations.length > 1 ||
                  accreditation.accreditationsId) &&
                accreditation.Mandatory !== 'Yes' &&
                !isFieldDisabled(accreditation)
              "
              class="d-flex justify-end mb-3"
            >
              <v-btn
                color="primary lighten-1"
                text
                @click="removeAccreditations(index, accreditation)"
              >
                <v-icon>delete</v-icon>Remove
              </v-btn>
            </div>
            <ValidationObserver :ref="'accreditationsForm' + index">
              <v-row>
                <v-col cols="12">
                  <v-card flat class="pa-6">
                    <v-row>
                      <!-- <v-col cols="4">
                            <ValidationProvider
                              ref="accreditationsProvider"
                              v-slot="{ errors }"
                              name="Accreditations"
                              rules="required"
                            >
                              <v-select
                                :id="'Accreditations'"
                                v-model="accreditation.accreditations"
                                outlined
                                :items="accreditationsList"
                                :error-messages="errors"
                                label="Accreditations*"
                              ></v-select>
                            </ValidationProvider>
                      </v-col>-->
                      <v-col
                        v-if="accreditation.Dependent_Id"
                        cols="12"
                        class="font-weight-medium"
                      >
                        {{
                          accreditation.Dependent_First_Name +
                          " " +
                          accreditation.Dependent_Last_Name +
                          ` (${accreditation.Relationship})`
                        }}
                      </v-col>
                      <v-col cols="12" lg="4" xl="4" md="6" sm="12" xs="12">
                        <ValidationProvider
                          :ref="'accreditationCategoryTypeProvider' + index"
                          v-slot="{ errors }"
                          name="Accreditation Category Type"
                          :rules="'required'"
                        >
                          <v-autocomplete
                            v-if="accreditation.Mandatory !== 'Yes'"
                            :id="'Accreditation Category Type Id'"
                            v-model="accreditation.accreditationAndType"
                            outlined
                            :disabled="isFieldDisabled(accreditation)"
                            :items="accreditationsTypeList"
                            :error-messages="errors"
                            :label="getFieldAlias(230).Field_Alias"
                            item-text="accreditationType"
                            item-value="accreditationCategoryAndTypeId"
                            :search-input.sync="accreditationSearch[index]"
                            @change="onFieldChange()"
                          >
                            <template #item="{ item }">
                              <div class="d-flex flex-column">
                                <div class="mt-2">
                                  {{ item.accreditationCategory }}
                                </div>
                                <div class="grey--text">
                                  {{ item.accreditationType }}
                                </div>
                              </div>
                            </template>
                          </v-autocomplete>
                          <v-text-field
                            v-else
                            :id="'Accreditation Category Type'"
                            v-model="accreditation.accreditationType"
                            disabled
                            outlined
                            :error-messages="errors"
                          >
                            <template v-slot:label>
                              {{
                                getFieldAlias(230) &&
                                getFieldAlias(230).Field_Alias
                                  ? getFieldAlias(230).Field_Alias
                                  : "Accreditation Category Type"
                              }}
                              <span
                                v-if="accreditation.Mandatory == 'Yes'"
                                style="color: red"
                                >*</span
                              >
                            </template>
                          </v-text-field>
                        </ValidationProvider>

                        <div
                          v-if="
                            instructionMap.has(
                              accreditation.accreditationAndType
                            ) &&
                            instructionMap.get(
                              accreditation.accreditationAndType
                            ) &&
                            instructionMap.get(
                              accreditation.accreditationAndType
                            ).FileName &&
                            instructionMap.get(
                              accreditation.accreditationAndType
                            ).Instruction
                          "
                          class="text-caption ml-2"
                          style="line-height: 1; font-weight: bold"
                        >
                          <span
                            v-html="
                              instructionFirstPart(
                                instructionMap.get(
                                  accreditation.accreditationAndType
                                ).Instruction
                              )
                            "
                          >
                          </span>
                          <span
                            style="
                              color: blue;
                              text-decoration: underline;
                              cursor: pointer;
                            "
                            @click="
                              retrieveFileAndRedirect(
                                instructionMap.get(
                                  accreditation.accreditationAndType
                                ).FileName
                              )
                            "
                            >here</span
                          >
                          <span
                            :style="
                              customStyles(
                                instructionMap.get(
                                  accreditation.accreditationAndType
                                ).Instruction
                              )
                            "
                            v-html="
                              instructionSecondPart(
                                instructionMap.get(
                                  accreditation.accreditationAndType
                                ).Instruction
                              )
                            "
                          ></span>
                        </div>
                      </v-col>
                      <v-col
                        v-if="
                          getFieldAlias(386) &&
                          getFieldAlias(386).Field_Visiblity == 'Yes'
                        "
                        cols="12"
                        lg="4"
                        xl="4"
                        md="6"
                        sm="12"
                        xs="12"
                      >
                        <ValidationProvider
                          ref="identifierProvider"
                          v-slot="{ errors }"
                          :name="getFieldAlias(386).Field_Alias"
                          :rules="
                            getFieldAlias(386).Mandatory_Field == 'Yes'
                              ? `required|alphaNumSpaceWithTwoSymbol`
                              : `alphaNumSpaceWithTwoSymbol`
                          "
                        >
                          <v-text-field
                            :id="'identifier'"
                            v-model="accreditation.identifier"
                            outlined
                            :disabled="isFieldDisabled(accreditation)"
                            :counter="50"
                            :label="getFieldAlias(386).Field_Alias"
                            :error-messages="errors"
                            @input="onFieldChange()"
                            ><template v-slot:label>
                              {{ getFieldAlias(386).Field_Alias }}
                              <span
                                v-if="
                                  getFieldAlias(386).Mandatory_Field == 'Yes' ||
                                  accreditation.Mandatory == 'Yes'
                                "
                                style="color: red"
                                >*</span
                              >
                            </template></v-text-field
                          >
                        </ValidationProvider>
                      </v-col>
                      <v-col
                        v-if="
                          getFieldAlias(246) &&
                          getFieldAlias(246).Field_Visiblity.toLowerCase() ==
                            'yes'
                        "
                        cols="12"
                        lg="4"
                        xl="4"
                        md="6"
                        sm="12"
                        xs="12"
                      >
                        <v-dialog
                          v-model="receivedDateModal[index]"
                          width="290"
                        >
                          <template #activator="{ on }">
                            <ValidationProvider
                              ref="receivedDateProvider"
                              v-slot="{ errors }"
                              :name="getFieldAlias(246).Field_Alias"
                              :rules="
                                getFieldAlias(
                                  246
                                ).Mandatory_Field.toLowerCase() === 'yes'
                                  ? 'required'
                                  : ''
                              "
                            >
                              <v-text-field
                                :id="'AccreditationsFrom'"
                                :value="formatDate(accreditation.receivedDate)"
                                outlined
                                readonly
                                :disabled="isFieldDisabled(accreditation)"
                                v-on="on"
                                :error-messages="errors"
                                @input="onFieldChange()"
                              >
                                <template v-slot:label>
                                  {{ getFieldAlias(246).Field_Alias }}
                                  <span
                                    v-if="
                                      getFieldAlias(
                                        246
                                      ).Mandatory_Field.toLowerCase() == 'yes'
                                    "
                                    style="color: red"
                                    >*</span
                                  >
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker
                            v-model="accreditation.receivedDate"
                            :min="minJoinDate"
                            :max="maxYear"
                            @change="emptyExpiryDate(index)"
                          ></v-date-picker>
                        </v-dialog>
                      </v-col>
                      <v-col cols="12" lg="4" xl="4" md="6" sm="12" xs="12">
                        <v-dialog v-model="expiryDateModal[index]" width="290">
                          <template #activator="{ on }">
                            <ValidationProvider
                              ref="expiryDateProvider"
                              v-slot="{ errors }"
                              name="Expiry Date"
                              rules="required"
                            >
                              <v-text-field
                                :id="'AccreditationsTo'"
                                :value="formatDate(accreditation.expiryDate)"
                                readonly
                                outlined
                                :disabled="
                                  !accreditation.receivedDate ||
                                  isFieldDisabled(accreditation)
                                "
                                v-on="on"
                                :error-messages="errors"
                                @input="onFieldChange()"
                              >
                                <template v-slot:label>
                                  Expiry Date
                                  <span style="color: red">*</span>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker
                            v-model="accreditation.expiryDate"
                            :min="accreditation.receivedDate"
                            @change="expiryDateModal[index] = false"
                          ></v-date-picker>
                        </v-dialog>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="4"
                        xl="4"
                        md="6"
                        sm="12"
                        xs="12"
                        v-if="
                          getFieldAlias(387) &&
                          getFieldAlias(387).Field_Visiblity == 'Yes'
                        "
                      >
                        <ValidationProvider
                          :ref="'examRating' + index"
                          v-slot="{ errors }"
                          :name="getFieldAlias(387).Field_Alias"
                          :rules="
                            getFieldAlias(387).Mandatory_Field == 'Yes'
                              ? `required|numeric|minimum:0|maximum:100`
                              : `numeric|minimum:0|maximum:100`
                          "
                        >
                          <v-text-field
                            :id="'examRating' + index"
                            v-model="accreditation.examRating"
                            type="number"
                            outlined
                            :disabled="isFieldDisabled(accreditation)"
                            :label="getFieldAlias(387).Field_Alias"
                            :error-messages="errors"
                            @input="onFieldChange()"
                          >
                            <template v-slot:label>
                              {{ getFieldAlias(387).Field_Alias }}
                              <span
                                v-if="
                                  getFieldAlias(387).Mandatory_Field == 'Yes'
                                "
                                style="color: red"
                                >*</span
                              >
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="4"
                        xl="4"
                        md="6"
                        sm="12"
                        xs="12"
                        v-if="
                          getFieldAlias(389) &&
                          getFieldAlias(389).Field_Visiblity == 'Yes'
                        "
                      >
                        <ValidationProvider
                          :ref="'examDateMonth' + index"
                          v-slot="{ errors }"
                          :name="getFieldAlias(389).Field_Alias"
                          :rules="
                            getFieldAlias(389).Mandatory_Field == 'Yes'
                              ? 'required'
                              : ''
                          "
                        >
                          <v-autocomplete
                            :id="'examDateMonth' + index"
                            v-model="accreditation.examDateMonth"
                            outlined
                            :disabled="isFieldDisabled(accreditation)"
                            :items="monthsList"
                            :label="getFieldAlias(389).Field_Alias"
                            :error-messages="errors"
                            @input="onFieldChange()"
                          >
                            <template v-slot:label>
                              {{ getFieldAlias(389).Field_Alias }}
                              <span
                                v-if="
                                  getFieldAlias(389).Mandatory_Field == 'Yes'
                                "
                                style="color: red"
                                >*</span
                              >
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="4"
                        xl="4"
                        md="6"
                        sm="12"
                        xs="12"
                        v-if="
                          getFieldAlias(388) &&
                          getFieldAlias(388).Field_Visiblity == 'Yes'
                        "
                      >
                        <ValidationProvider
                          :ref="'examDateYear' + index"
                          v-slot="{ errors }"
                          :name="getFieldAlias(388).Field_Alias"
                          :rules="
                            getFieldAlias(388).Mandatory_Field == 'Yes'
                              ? 'required'
                              : ''
                          "
                        >
                          <v-autocomplete
                            :id="'examDateYear' + index"
                            v-model="accreditation.examDateYear"
                            outlined
                            :disabled="isFieldDisabled(accreditation)"
                            :items="yearList"
                            :label="getFieldAlias(388).Field_Alias"
                            :error-messages="errors"
                            @input="onFieldChange()"
                          >
                            <template v-slot:label>
                              {{ getFieldAlias(388).Field_Alias }}
                              <span
                                v-if="
                                  getFieldAlias(388).Mandatory_Field == 'Yes'
                                "
                                style="color: red"
                                >*</span
                              >
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" lg="4" xl="4" md="6" sm="12" xs="12">
                        <DragAndDropFiles
                          :id="'accreditation' + index"
                          file-category="accreditation"
                          :key-index="'accreditation-file-upload-' + index"
                          :old-file-name="accreditation.fileNameWithoutFormat"
                          :Mandatory="
                            isAccreditationDocumentMandatory(accreditation)
                          "
                          :disabled="isFieldDisabled(accreditation)"
                          :is-error="accreditation.fileValidationError"
                          @file-event-success="updateFileName($event, index)"
                          @file-event-triggered="isFileLoading = $event"
                          :message="true"
                        />
                      </v-col>
                      <v-col
                        v-if="allowRemarksWithoutAccreditationDocument"
                        cols="12"
                        lg="4"
                        xl="4"
                        md="6"
                        sm="12"
                        xs="12"
                      >
                        <ValidationProvider
                          :ref="'accreditationRemarks' + index"
                          v-slot="{ errors }"
                          name="Remarks"
                          rules="min:3|max:500|multilingualNameValidation"
                        >
                          <v-textarea
                            :id="'accreditationRemarks' + index"
                            v-model="accreditation.remarks"
                            outlined
                            :disabled="isFieldDisabled(accreditation)"
                            :counter="500"
                            :maxlength="500"
                            rows="1"
                            prepend-inner-icon="mdi-information-outline"
                            label="Remarks"
                            :error-messages="errors"
                            @input="onFieldChange()"
                          >
                            <template v-slot:prepend-inner>
                              <v-tooltip bottom max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    small
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span style="white-space: normal">
                                  Please provide a valid reason if the requested
                                  document is unavailable.
                                </span>
                              </v-tooltip>
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </ValidationObserver>
            <v-divider></v-divider>
          </v-form>
          <v-overlay
            absolute
            :value="accreditationLoading || saveLoading"
            color="#fff"
            z-index="1"
          >
            <v-progress-circular
              color="primary"
              indeterminate
              size="50"
            ></v-progress-circular>
          </v-overlay>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  GET_ACCREDITATIONS,
  ADD_ACCREDITATIONS,
  UPDATE_ACCREDITATIONS,
  LIST_ACCREDITATIONS_AND_TYPES,
  DELETE_ACCREDITATIONS,
  GET_FORM_FIELDS_AND_TYPE,
  RETRIEVE_MANDATORY_ACCREDITATIONS,
} from "@/graphql/OnboardingQueries";
import DragAndDropFiles from "@/components/custom-components/DragAndDropFiles.vue";
import moment from "moment";
import { scrollScreenToTop } from "../../../helper";
import config from "@/config.js";

export default {
  name: "AccreditationsDetails",

  components: { DragAndDropFiles },

  props: {
    candidateSettings: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    addAccreditations: [],
    accreditationsList: [],
    accreditationsTypeList: [],
    receivedDateModal: [],
    expiryDateModal: [],
    maxYear: "",
    minJoinDate: "",
    saveLoading: false,
    apiCallCount: 0,
    accreditationLoading: true,
    isFileLoading: false,
    accreditationSearch: [],
    formList: [],
    mandatoryAccredidations: [],
    instructionMap: new Map(),
  }),

  created() {
    let storedDob = localStorage.getItem("DOB");
    if (storedDob && storedDob !== "null") {
      this.minJoinDate = moment(storedDob).format("YYYY-MM-DD");
    }
    this.maxYear = moment().format("YYYY-MM-DD");
  },

  apollo: {},

  computed: {
    formatDate() {
      return (date) => {
        return date ? moment(date).format("DD/MM/YYYY") : "";
      };
    },
    monthsList() {
      return moment.months();
    },
    yearList() {
      let empDob = localStorage.getItem("DOB");
      let year = 0;
      if (empDob) {
        year = new Date().getFullYear() - new Date(empDob).getFullYear();
      } else {
        year = 80;
      }
      const now = new Date().getUTCFullYear();
      const years = Array(now - (now - year))
        .fill("")
        .map((v, idx) => now - idx);
      return years;
    },
    isAustralian() {
      let country = localStorage.getItem("country");
      if (country && country.toLowerCase() === "au") {
        return true;
      }
      return false;
    },
    instructionFirstPart() {
      return (instruction) => {
        let str = instruction.replace(/^<p>|<\/p>$/g, "");
        return str.split("{{")[0] ? str.split("{{")[0] : "";
      };
    },
    instructionSecondPart() {
      return (instruction) => {
        let str = instruction.replace(/^<p>|<\/p>$/g, "");
        return str.split("}}")[1] ? str.split("}}")[1] : "";
      };
    },
    customStyles() {
      return (instruction) => {
        const styleRegex = /style="([^"]*)"/;
        const match = instruction.match(styleRegex);

        if (match) {
          const styles = match[1]; // Extracted styles
          return styles;
        } else {
          return "";
        }
      };
    },
    domainName() {
      return config.domain;
    },
    candidateStatus() {
      return localStorage.getItem("candidateStatus");
    },
    allowRemarksWithoutAccreditationDocument() {
      return (
        this.candidateSettings?.Allow_Remarks_Without_Accreditation_Document?.toLowerCase() ===
        "yes"
      );
    },
    isFieldDisabled() {
      return (accreditation) => {
        if (
          this.candidateStatus?.toLowerCase() === "returned" &&
          this.candidateSettings?.Allow_Only_Unverified_Edit?.toLowerCase() ===
            "yes" &&
          accreditation?.accreditationsId
        ) {
          return accreditation.verificationStatus?.toLowerCase() !== "returned";
        }
        return false;
      };
    },
  },

  mounted() {
    scrollScreenToTop();
    if (!this.isAustralian) {
      this.$emit("mandatory-docs", true);
    }
    this.retrieveAccreditationAndType();
    this.getFieldProps();
  },

  methods: {
    onFieldChange() {
      this.$emit("form-dirty");
    },
    getFieldAlias(fieldId) {
      return this.formList.find((field) => field.Field_Id === fieldId) || {};
    },
    isAccreditationDocumentMandatory(accreditation) {
      if (this.allowRemarksWithoutAccreditationDocument) {
        return !(accreditation?.remarks && accreditation.remarks.trim());
      }
      return true;
    },
    getFieldProps() {
      let vm = this;
      vm.saveLoading = true;
      this.$apollo
        .query({
          query: GET_FORM_FIELDS_AND_TYPE,
          variables: {
            form_Id: 178,
          },
          client: "apolloClientB",
        })
        .then((res) => {
          if (res.data.getFormFeildsByFormIdAndTab) {
            this.formList = res.data.getFormFeildsByFormIdAndTab.formFields;
          }
          vm.saveLoading = false;
        })
        .catch(() => {
          vm.saveLoading = false;
        });
    },
    retrieveAccreditationAndType() {
      let vm = this;
      vm.$apollo
        .query({
          query: LIST_ACCREDITATIONS_AND_TYPES,
          client: "apolloClientB",
          variables: {
            urlHash: localStorage.getItem("urlHash"),
          },
        })
        .then((data) => {
          data = data.data;
          if (data && data.retrieveAccreditationAndType) {
            this.accreditationsTypeList =
              data.retrieveAccreditationAndType.accreditationAndType;
          }
          this.retrieveMandatoryAccreditations();
        });
    },
    retrieveAccreditationDetails() {
      const defaultAccreditation = {
        accreditationAndType: 0,
        identifier: "",
        receivedDate: "",
        expiryDate: "",
        fileName: "",
        fileNameWithoutFormat: "",
        accreditationsId: 0,
        fileValidationError: "",
        Mandatory: "No",
        examDateMonth: "",
        examDateYear: null,
        examRating: null,
        Dependent_Id: null,
        Dependent_First_Name: "",
        Dependent_Last_Name: "",
        Relationship: "",
        verificationStatus: "",
        remarks: "",
      };

      let vm = this;
      vm.accreditationLoading = true;
      vm.$apollo
        .query({
          query: GET_ACCREDITATIONS,
          client: "apolloClientB",
          fetchPolicy: "no-cache",
          variables: {
            urlHash: localStorage.getItem("urlHash"),
          },
        })
        .then(({ data }) => {
          const accreditationDetails =
            data?.retrieveAccreditationDetails?.accreditationDetails || [];

          if (accreditationDetails.length > 0) {
            this.addAccreditations = accreditationDetails
              .sort((a, b) => {
                // Items without dependentId come first
                if (!a.dependentId && b.dependentId) return -1;
                if (a.dependentId && !b.dependentId) return 1;
                return 0;
              })
              .map((accreditation) => ({
                accreditationType: accreditation.accreditationType,
                accreditationAndType:
                  accreditation.accreditationCategoryAndTypeId,
                identifier: accreditation.identifier,
                receivedDate: accreditation.receivedDate,
                expiryDate: accreditation.expiryDate,
                accreditationsId: accreditation.accreditationDetailId,
                fileName: accreditation.fileName
                  ? accreditation.fileName.split("?")[3]
                  : "",
                fileNameWithoutFormat: accreditation.fileName,
                fileValidationError: "",
                Mandatory: accreditation.Mandatory,
                examRating:
                  accreditation.examRating != null
                    ? parseInt(accreditation.examRating)
                    : null,
                examDateYear: accreditation.examDateYear
                  ? parseInt(accreditation.examDateYear)
                  : null,
                examDateMonth: accreditation.examDateMonth,
                Dependent_Id: accreditation.dependentId,
                Dependent_First_Name: accreditation.dependentFirstName,
                Dependent_Last_Name: accreditation.dependentLastName,
                Relationship: accreditation.relationship,
                verificationStatus: accreditation.verificationStatus,
                remarks: accreditation.remarks || "",
              }));
          }

          if (this.mandatoryAccredidations.length > 0) {
            const existingIds = new Set(
              this.addAccreditations.map((doc) => doc.accreditationAndType)
            );

            const missingMandatoryDocs = this.mandatoryAccredidations
              .filter(
                (item) =>
                  !existingIds.has(item.Accreditation_Category_And_Type_Id)
              )
              .map((item) => ({
                ...defaultAccreditation,
                accreditationType: item.Accreditation_Type,
                accreditationAndType: item.Accreditation_Category_And_Type_Id,
                accreditationsId: null,
                Dependent_Id: item.Dependent_Id,
                Dependent_First_Name: item.Dependent_First_Name,
                Dependent_Last_Name: item.Dependent_Last_Name,
                Relationship: item.Relationship,
                Mandatory: "Yes",
              }));
            if (missingMandatoryDocs.length) {
              this.$emit("mandatory-docs", false);
            }

            this.addAccreditations.push(...missingMandatoryDocs);
          }

          // Add default accreditation if no existing or mandatory accreditations
          if (!this.addAccreditations.length) {
            this.addAccreditations.push({ ...defaultAccreditation });
          }
        })
        .catch(() => {
          this.addAccreditations.push({ ...defaultAccreditation });
        })
        .finally(() => {
          this.accreditationLoading = false;
        });
    },
    accreditationInfoDetails() {
      let isValid = this.validateAccreditations();
      if (isValid) {
        return this.addAccreditations;
      }
    },
    updateFileName(fileName, index) {
      this.addAccreditations[index]["fileNameWithoutFormat"] = fileName;
      this.addAccreditations[index]["fileValidationError"] = "";
      this.onFieldChange();
    },

    onClickPrevBtn() {
      this.$emit("back-to-prev");
    },

    addMoreAccreditations() {
      this.validateAccreditations().then((isValid) => {
        if (isValid) {
          this.addAccreditations.push({
            accreditationAndType: 0,
            identifier: "",
            receivedDate: "",
            expiryDate: "",
            fileName: "",
            fileNameWithoutFormat: "",
            fileValidationError: "",
            accreditationsId: 0,
            Mandatory: "No",
            examDateMonth: "",
            examDateYear: null,
            examRating: null,
            verificationStatus: "",
            remarks: "",
          });
        }
      });
    },

    emptyExpiryDate(index) {
      this.addAccreditations[index]["expiryDate"] = "";
      this.receivedDateModal[index] = false;
    },

    validateAccreditations() {
      return new Promise((resolve) => {
        let callCount = 0,
          isValidCount = 0;
        for (let aIndex in this.addAccreditations) {
          this.$refs["accreditationsForm" + aIndex][0]
            .validate()
            .then((validationResponse) => {
              callCount += 1;
              let aIndexFileName =
                this.addAccreditations[aIndex]["fileNameWithoutFormat"];
              let isDocMandatory = this.isAccreditationDocumentMandatory(
                this.addAccreditations[aIndex]
              );
              if (validationResponse && (!isDocMandatory || aIndexFileName)) {
                isValidCount += 1;
                if (callCount === this.addAccreditations.length) {
                  resolve(isValidCount === this.addAccreditations.length);
                }
              } else if (isDocMandatory && !aIndexFileName) {
                this.addAccreditations[aIndex]["fileValidationError"] =
                  "Document is required";
                resolve(false);
              }
            });
        }
      });
    },

    onSaveAccreditations() {
      this.apiCallCount = 0;
      for (let accreditation of this.addAccreditations) {
        this.validateAccreditations().then((isValid) => {
          if (isValid) {
            this.apiCallCount += 1;
            if (accreditation.accreditationsId) {
              this.updateAccreditationsDetails(accreditation);
            } else {
              this.addAccreditationsDetails(accreditation);
            }
          }
        });
      }
    },

    addAccreditationsDetails(accreditationsItem) {
      let vm = this;
      vm.saveLoading = true;
      vm.$apollo
        .mutate({
          mutation: ADD_ACCREDITATIONS,
          variables: {
            urlHash: localStorage.getItem("urlHash"),
            accreditationCategoryAndTypeId:
              accreditationsItem.accreditationAndType
                ? accreditationsItem.accreditationAndType
                : accreditationsItem.accreditationCategoryAndTypeId,
            identifier: accreditationsItem.identifier,
            receivedDate:
              accreditationsItem.receivedDate &&
              accreditationsItem.receivedDate != "Invalid date"
                ? accreditationsItem.receivedDate
                : null,
            expiryDate:
              accreditationsItem.expiryDate &&
              accreditationsItem.expiryDate != "Invalid date"
                ? accreditationsItem.expiryDate
                : null,
            fileName: accreditationsItem.fileNameWithoutFormat,
            examRating: accreditationsItem.examRating
              ? parseInt(accreditationsItem.examRating)
              : null,
            examDateYear: accreditationsItem.examDateYear
              ? parseInt(accreditationsItem.examDateYear)
              : null,
            examDateMonth: accreditationsItem.examDateMonth,
            dependentId: accreditationsItem.Dependent_Id,
            remarks: accreditationsItem.remarks || "",
          },
          client: "apolloClientC",
        })
        .then(() => {
          if (vm.apiCallCount === vm.addAccreditations.length) {
            vm.$emit("accreditations-saved");
          }
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
          if (vm.apiCallCount === vm.addAccreditations.length) {
            vm.saveLoading = false;
          }
        });
    },

    updateAccreditationsDetails(accreditationsItem) {
      let vm = this;
      vm.saveLoading = true;
      vm.$apollo
        .mutate({
          mutation: UPDATE_ACCREDITATIONS,
          variables: {
            urlHash: localStorage.getItem("urlHash"),
            accreditationCategoryAndTypeId:
              accreditationsItem.accreditationAndType,
            identifier: accreditationsItem.identifier,
            receivedDate:
              accreditationsItem.receivedDate &&
              accreditationsItem.receivedDate != "Invalid date"
                ? accreditationsItem.receivedDate
                : null,
            expiryDate:
              accreditationsItem.expiryDate &&
              accreditationsItem.expiryDate != "Invalid date"
                ? accreditationsItem.expiryDate
                : null,
            fileName: accreditationsItem.fileNameWithoutFormat,
            accreditationDetailId: accreditationsItem.accreditationsId,
            examRating: accreditationsItem.examRating
              ? parseInt(accreditationsItem.examRating)
              : null,
            examDateYear: accreditationsItem.examDateYear
              ? parseInt(accreditationsItem.examDateYear)
              : null,
            examDateMonth: accreditationsItem.examDateMonth,
            dependentId: accreditationsItem.Dependent_Id,
            remarks: accreditationsItem.remarks || "",
          },
          client: "apolloClientC",
        })
        .then(() => {
          if (vm.apiCallCount === vm.addAccreditations.length) {
            vm.$emit("accreditations-saved");
          }
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
          if (vm.apiCallCount === vm.addAccreditations.length) {
            vm.saveLoading = false;
          }
        });
    },

    removeAccreditations(index, accreditationsItem) {
      if (accreditationsItem.accreditationsId) {
        let vm = this;
        this.$apollo
          .mutate({
            mutation: DELETE_ACCREDITATIONS,
            variables: {
              urlHash: localStorage.getItem("urlHash"),
              accreditationDetailId: accreditationsItem.accreditationsId,
            },
            client: "apolloClientC",
          })
          .then(() => {
            let snackbarData = {
              isOpen: true,
              message: "Deleted Successfully",
              type: "success",
            };
            vm.showAlert(snackbarData);
            vm.addAccreditations.splice(index, 1);
            if (index === 0 && vm.addAccreditations.length === 0) {
              vm.addAccreditations.push({
                accreditationAndType: "",
                identifier: "",
                receivedDate: "",
                expiryDate: "",
                fileName: "",
                fileNameWithoutFormat: "",
                fileValidationError: "",
                accreditationsId: 0,
                Mandatory: "No",
                examDateMonth: "",
                examDateYear: null,
                examRating: null,
                remarks: "",
              });
              if (vm.isAustralian) {
                vm.$emit("mandatory-docs", false);
              }
            }
          })
          .catch((deleteErr) => {
            let snackbarData = {
              isOpen: true,
              message:
                deleteErr.graphQLErrors.length !== 0
                  ? deleteErr.graphQLErrors[0].message
                  : "Something went wrong. It could be a possibility due to network connectivity error..",
              type: "warning",
            };
            vm.showAlert(snackbarData);
          });
      } else {
        this.addAccreditations.splice(index, 1);
      }
    },

    // show error or success message
    showAlert(snackbarData) {
      this.$store.commit("OPEN_SNACKBAR", snackbarData);
    },
    retrieveMandatoryAccreditations() {
      let vm = this;
      vm.$apollo
        .query({
          query: RETRIEVE_MANDATORY_ACCREDITATIONS,
          client: "apolloClientB",
          variables: {
            urlHash: localStorage.getItem("urlHash"),
          },
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          let { data } = response;
          if (
            data &&
            data.listCandidateAccreditationDetails &&
            data.listCandidateAccreditationDetails.accreditationDetails &&
            data.listCandidateAccreditationDetails.accreditationDetails.length
          ) {
            let filteredList =
              data.listCandidateAccreditationDetails.accreditationDetails.filter(
                (ele) => ele.Mandatory === "Yes"
              );
            this.mandatoryAccredidations = [...filteredList];

            const instructionMap = new Map(
              this.mandatoryAccredidations.map((item) => [
                item.Accreditation_Category_And_Type_Id,
                {
                  Instruction: item.Instruction,
                  FileName: item.File_Name,
                },
              ])
            );
            this.instructionMap = instructionMap;
          } else {
            this.mandatoryAccredidations = [];
          }
          this.retrieveAccreditationDetails();
        })
        .catch(() => {
          this.mandatoryAccredidations = [];
          this.retrieveAccreditationDetails();
        });
    },
    async retrieveFileAndRedirect(fileName) {
      this.isFileLoading = true;
      await this.$store
        .dispatch("s3FileUploadRetrieveAction", {
          fileName:
            this.domainName +
            "/" +
            localStorage.getItem("orgCode") +
            "/" +
            "Accreditations" +
            "/" +
            fileName,
          action: "download",
          type: "documents",
        })
        .then((resFileName) => {
          window.open(resFileName, "_blank");
          this.isFileLoading = false;
        })
        .catch((err) => {
          this.isFileLoading = false;
          let snackbarData = {
            isOpen: true,
            message:
              err.graphQLErrors && err.graphQLErrors.length !== 0
                ? err.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          this.showAlert(snackbarData);
        });
    },
  },
};
</script>
